// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"61e10ed1","163":"61e10ed1","196":"61e10ed1","269":"61e10ed1","337":"61e10ed1","366":"61e10ed1","560":"61e10ed1","701":"61e10ed1","858":"61e10ed1","879":"61e10ed1","997":"61e10ed1"}[chunkId] + ".chunk.css";
};